import React from 'react';
import { DownloadIcon, GlobeIcon, LockIcon } from 'lucide-react';
const notes = [{
  label: 'Paiement 100 % sécurisé et crypté',
  Icon: LockIcon
}, {
  label: 'Paiement traité dans votre devise locale',
  Icon: GlobeIcon
}, {
  label: 'Accès numérique immédiat',
  Icon: DownloadIcon
}];

/** Reassurance shown right under the checkout button. */
export function SecurePaymentNote({
  className = ''
}: {
  className?: string;
}) {
  return <ul role="list" className={`mx-auto flex w-full max-w-[420px] flex-col gap-2.5 rounded-[14px] border border-brand-cta/25 bg-brand-cta/[0.06] px-5 py-4 text-left ${className}`} data-id="element-182" data-mp="1m6wzpykbubi9">
      {notes.map(({
      label,
      Icon
    }) => <li key={label} className="flex items-center gap-2.5 font-body text-[13px] font-semibold text-brand-charcoal" data-id="element-183" data-mp="1zytmro751v7s">
          <Icon className="h-4 w-4 flex-none text-brand-cta" strokeWidth={2} aria-hidden="true" data-id="element-184" data-mp="24yfzlwj219g2" />
          {label}
        </li>)}
    </ul>;
}